<template>
  <div>
    <div class="h-screen flex overflow-hidden bg-gray-400">
      <div class="flex flex-col w-0 flex-1 overflow-hidden">
        <div class="relative z-10 shrink-0 flex h-16 bg-gray-100 shadow">
          <div class="flex-1 px-4 flex justify-between">
            <div class="flex-1 flex items-center">
              <h1
                class="w-full md:ml-0"
                v-if="$slots.sectionTitle"
              >
                <slot name="sectionTitle" />
              </h1>
              <h1
                class="w-full md:ml-0"
                v-else
              >
                Salve Platform
              </h1>
            </div>
            <div class="ml-4 flex items-center md:ml-6">
              <div class="ml-3 relative">
                <div>
                  <button
                    @click="showingNotifications = !showingNotifications"
                    type="button"
                    class="btn btn-secondary-outline"
                  >
                    <span class="sr-only">View notifications</span>
                    <!-- Heroicon name: outline/bell -->
                    N
                  </button>
                </div>
              </div>

              <Menu
                as="div"
                class="relative inline-block text-left ml-3"
              >
                <div>
                  <MenuButton class="btn btn-secondary"> JZ </MenuButton>
                </div>

                <transition
                  enter-active-class="transition ease-out duration-100"
                  enter-from-class="opacity-0 scale-95"
                  enter-to-class="opacity-100 scale-100"
                  leave-active-class="transition ease-in duration-75"
                  leave-from-class="opacity-100 scale-100"
                  leave-to-class="opacity-0 scale-95"
                >
                  <MenuItems
                    class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-gray-100 ring-1 ring-gray-400 ring-opacity-5 focus:outline-none"
                  >
                    <div class="py-1">
                      <MenuItem v-slot="{ active }">
                        <Link
                          :href="route('user.edit')"
                          class="block px-4 py-2 text-sm text-gray-700"
                        >
                          Edit Profile
                        </Link>
                      </MenuItem>
                      <MenuItem v-slot="{ active }">
                        <a
                          :href="route('logout')"
                          method="post"
                          as="button"
                          type="button"
                          class="block px-4 py-2 text-sm text-gray-700"
                        >
                          Sign Out
                        </a>
                      </MenuItem>
                    </div>
                  </MenuItems>
                </transition>
              </Menu>
            </div>
          </div>
        </div>

        <main class="flex-1 relative overflow-y-auto focus:outline-none">
          <div class="py-6">
            <div class="max-w-5xl mx-auto md:flex md:items-center md:justify-center px-4 sm:px-6 md:px-8">
              <div class="flex-1 min-w-0">
                <h2
                  class="text-2xl font-semibold text-gray-900 text-center"
                  v-if="$slots.pageTitle"
                >
                  <slot name="pageTitle" />
                </h2>
                <h2
                  class="text-2xl font-semibold text-gray-900 text-center"
                  v-else
                >
                  Salve Platform
                </h2>
              </div>
              <div class="mt-4 flex md:mt-0 md:ml-4">
                <slot name="headingOptions"></slot>
              </div>
            </div>
            <div class="max-w-5xl mx-auto px-4 sm:px-6 md:px-8 pt-4">
              <!-- Replace with your content -->
              <div class="py-4">
                <slot />
              </div>
              <!-- /End replace -->
            </div>
          </div>
        </main>
      </div>
    </div>

    <slot name="modals" />
  </div>
</template>

<script>
import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue'
import SalveLogo from '@/Components/SalveLogo.vue'
import SideNav from '@/Layouts/Components/SideNav.vue'
import { Link } from '@inertiajs/vue3'
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'

export default {
  components: {
    BreezeApplicationLogo,
    SalveLogo,
    SideNav,
    Link,
    Menu,
    MenuButton,
    MenuItem,
    MenuItems
  },

  data() {
    return {
      showingNavigation: false
    }
  }
}
</script>
